import React, { Component } from 'react';

import './consumoHome.css'

import EmpresaPlan from './empresaPlanCom/empresaPlan';
import MensajesPlan from './mensajesPlanCom/mensajePlan';
import CambiarPlan from './cambiarPlanCom/cambiarPlan';

class Consumo extends Component {

    constructor(){
        super();
        this.state = { 

        }
    }


    render(){
        return(
            <div className='col s9 xl9 contenedorConsumo'>
                <div className='row'>
                    <div className='col s12 m6 xl4'>
                        <EmpresaPlan />
                        <MensajesPlan />
                    </div>
                    <div className='col s12 m6 xl5'>
                        <CambiarPlan />
                    </div>
                </div>
            </div>
        );
    }


}

export default Consumo;